export default "__VITE_ASSET__BivHN7mr__"